export const SET_CONTEXT_HELP = 'contextHelp/SET_CONTEXT_HELP';

export const setContextHelp = payload => ({
  type: SET_CONTEXT_HELP,
  payload,
});
